<ng-template #popover>
  <am-alert-content [title]="'RESULT-FLEXIBLE-FILTER'" [imageName]="image"></am-alert-content> 
</ng-template>

<mb-card class="flexible-card" elevation="hover" [style.margin-bottom]="type === 'FLEXIBLE' && '8px'">
  <div class="flexible-filter" [mb-popover]="popover" [mbPopoverShow]="false" [mbPopoverDismissible]="true"
    mbPopoverColor="light" mbPopoverPosition="right">
    <div class="flexible-filter__header">
      <mb-icon class="flexible-filter__icon" [icon]="icon"></mb-icon>
      <span class="flexible-filter__title" i18n="@@flexiblerate__filter__title">
        {type, select, OFFERS {Ofertas} FLEXIBLE {Reserva flexible}}
      </span>
    </div>
    <ng-content></ng-content>
  </div>
</mb-card>